import React from "react";
import styles from "./styles.js"

const SwitchFake = ({fakeTitle=true}) => {
  return (
    <>
      <div className="skeleton switch-fake--charac" />
      <style jsx>{styles}</style>
    </>
  );
}

export default SwitchFake;